/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


window.onload = function() {
  console.log("loaded");
}
document.addEventListener("variant:change", function (event) {

  const priceElement = document.querySelectorAll(
    ".custom-price"
  );
  
  const thumbnails = document.querySelectorAll(
    ".product-gallery__thumbnail"
  );
  const images =  document.querySelectorAll(
    ".product-gallery__media"
  );
  var variant = event.detail.variant; // Gives you access to the whole variant details
  /******************start updating variant price************************/
  if(priceElement && priceElement.length > 0) {
        const price = (0.9*variant.price)/100;
        const updatedPrice = price.toLocaleString('en-IN', {
          maximumFractionDigits: 0,
          currency: 'INR'
        });
        priceElement[0].innerText = "Rs. " + updatedPrice;
    }

  /******************end updating variant price************************/
  const variantAlt = variant.featured_media.alt;
  if (!variantAlt) {
    return;
  }
  thumbnails.forEach((element) => {
    const imgElements = element.getElementsByTagName('img');
    if(imgElements && imgElements.length > 0) {
      let imgElement = imgElements[0]
      let imgElementAlt = imgElement.alt;
      if (imgElementAlt == 'all' || imgElementAlt == variantAlt || (variantAlt != undefined && variantAlt != '' && variantAlt.indexOf(imgElementAlt) >= 0) ) {
            element.classList.remove("hide");
      } else {

        if(!element.classList.contains('hide')) {
          element.classList.add('hide')
        }
      }
    }});
  images.forEach((element) => {
    const imgElements = element.getElementsByTagName('img');
    if(imgElements && imgElements.length > 0) {
      let imgElement = imgElements[0]
      let imgElementAlt = imgElement.alt;
      if (imgElementAlt == 'all' || imgElementAlt == variantAlt || (variantAlt != undefined && variantAlt != '' && variantAlt.indexOf(imgElementAlt) >= 0) ) {
            element.classList.remove("hide");
      } else {

        if(!element.classList.contains('hide')) {
          element.classList.add('hide')
        }
      }
    }});
})
